<div class="container single-view" id="add-user">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/users/"
          class="inline-flex items-center text-base link link-icon left-arrow">{{ 'USERS.BTN_BACK_TO_USER' | translate
          }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-user-title" class="section-title">{{ 'USER_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-user-subtitle" class="section-subtitle mt-1 text-base">{{ 'USER_CREATE.SUBTITLE' |
            translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="userForm" data-testid="add-user-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-user-details" class="border-b pb-3">{{ 'USER_CREATE.USER_DETAILS' | translate }}
                  </h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-user-field-firstname" class="block text-sm" for="firstname">{{
                    'USER_CREATE.FIRST_NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-user-firstname-input" type="text" id="firstname" formControlName="firstname"
                    autocomplete="off">
                  @if (userForm.get('firstname')?.invalid && (userForm.get('firstname')?.touched ||
                  userForm.get('firstname')?.dirty)) {
                  <small data-testid="firstname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate
                    }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-user-field-romanisedfirstname" class="block text-sm"
                    for="romanisedFirstName">{{ 'USER_CREATE.ROMANIZED_FIRST_NAME' | translate }}</label>
                  <input data-testid="add-user-romanisedfirstname-input" type="text" id="romanisedFirstName"
                    formControlName="romanisedFirstName" autocomplete="off">
                  @if (userForm.get('romanisedFirstName')?.invalid && (userForm.get('romanisedFirstName')?.dirty ||
                  userForm.get('romanisedFirstName')?.touched)) {
                  @if (userForm.get('romanisedFirstName')?.errors?.['invalidCharacters']) {
                  <small data-testid="romanisedfirstname-format" class="p-error">
                    {{ 'USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                  </small>
                  }
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-user-field-lastname" class="block text-sm" for="lastname">{{
                    'USER_CREATE.LAST_NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-user-lastname-input" type="text" id="lastname" formControlName="lastname"
                    autocomplete="off">
                  @if (userForm.get('lastname')?.invalid && (userForm.get('lastname')?.touched ||
                  userForm.get('lastname')?.dirty)) {
                  <small data-testid="lastname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate
                    }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-user-field-romanisedlastname" class="block text-sm" for="romanisedLastName">{{
                    'USER_CREATE.ROMANIZED_LAST_NAME' | translate }} </label>
                  <input data-testid="add-user-romanisedlastname-input" type="text" id="romanisedLastName"
                    formControlName="romanisedLastName" autocomplete="off">
                  @if (userForm.get('romanisedLastName')?.invalid && (userForm.get('romanisedLastName')?.dirty ||
                  userForm.get('romanisedLastName')?.touched)) {
                  @if (userForm.get('romanisedLastName')?.errors?.['invalidCharacters']) {
                  <small data-testid="romanisedlastname-format" class="p-error">
                    {{ 'USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                  </small>
                  }
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-user-field-username" class="block text-sm" for="username">{{
                    'USER_CREATE.USERNAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-user-username-input" type="text" id="username" formControlName="username"
                    autocomplete="off">
                  @if (userForm.get('username')?.dirty || userForm.get('username')?.touched) {
                  @if (userForm.get('username')?.hasError('required')) {
                  <small data-testid="username-mandatory" class="p-error">
                    {{ 'USER_CREATE.USERNAME_REQUIRED' | translate }}
                  </small>
                  }
                  @if (userForm.get('username')?.hasError('minlength')) {
                  <small data-testid="username-format-length" class="p-error">
                    {{ 'USER_CREATE.USERNAME_MIN_LENGTH' | translate }}
                  </small>
                  }
                  @if (userForm.get('username')?.hasError('spacesFound')) {
                  <small data-testid="username-format-spaces" class="p-error">
                    {{ 'USER_CREATE.USERNAME_CANNOT_CONTAIN_SPACES' | translate }}
                  </small>
                  }
                  @if (userForm.get('username')?.hasError('usernameTaken')) {
                  <small data-testid="username-taken" class="p-error">
                    {{ 'USER_CREATE.USERNAME_TAKEN' | translate }}
                  </small>
                  }
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-user-field-roles" class="block text-sm" for="roleId">{{ 'USER_UPDATE.ROLE' |
                    translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown data-testid="roles" [placeholder]="'USER_UPDATE.SELECT_A_ROLE' | translate"
                    optionLabel="text" optionValue="id" [isMultiselect]="false" [showSelectionChips]="true"
                    [showClear]="true" [searchMode]="'remote'" [pageSize]="combosData['roles'].rowsPerPageOption || 5"
                    [totalCount]="combosData['roles'].totalRecords" [totalPages]="getComboTotalPages('roles')"
                    [options]="combosData['roles'].list" formControlName="roleId"
                    (onLazyLoad)="onLazyLoadComboData('roles', $event)">
                  </app-custom-dropdown>
                  @if (userForm.get('roleId')?.invalid && userForm.get('roleId')?.touched) {
                  <small data-testid="roles-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-user-field-language" class="block text-sm" for="language">{{ 'USER_CREATE.LANGUAGE' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="selector-input-languages"
                    [optionTestIdPrefix]="'listbox-item-'"
                    [options]="languages"
                    optionLabel="language"
                    optionValue="code"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showSearchbox]="true"
                    [showClear]="false"
                    [searchMode]="'local'"
                    [pageSize]="10"
                    [placeholder]="'USER_CREATE.LANGUAGE_DROPDOWN_PLACEHOLDER' | translate"
                    formControlName="selectedLanguage">
                  </app-custom-dropdown>
                  @if (userForm.get('selectedLanguage')?.dirty || userForm.get('selectedLanguage')?.touched) {
                  <div class="error-hint-wr">
                    @if (userForm.get('selectedLanguage')?.hasError('required')) {
                    <small data-testid="language-invalid" class="p-error">
                      {{ 'USER_CREATE.VALIDATE_LANGUAGE' | translate }}
                    </small>
                    }
                  </div>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-user-field-email" class="block text-sm" for="email">{{ 'USER_CREATE.EMAIL' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-user-email-input" type="text" id="email" formControlName="email" tabindex="16" autocomplete="off">
                  @if (
                  userForm.get('email')?.invalid && (userForm.get('email')?.dirty ||
                  userForm.get('email')?.touched)) {
                    @if (userForm.get('email')?.hasError('required')) {
                      <small data-testid="email-mandatory" class="p-error">{{ 'YOUR_ACCOUNT.VALIDATE_EMAIL' | translate }}</small>
                    }
                    @if (userForm.get('email')?.errors?.['invalidEmail']) {
                      <small data-testid="email-format" class="p-error">{{ 'YOUR_ACCOUNT.VALIDATE_EMAIL_SYNTAX' | translate }}</small>
                    }
                  }
                </div>
              </div>
              <div class="row">
                <div class="flex flex-col col-12 mb-4 mt-4">
                  <h2 data-testid="add-user-markets-retailers-details" class="border-b pb-3">{{ 'USER_UPDATE.USER_RETAILERS_AND_MARKETS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [ngClass]="{ 'disabled': !isRoleSelected() || isMarketsFieldDisabled }">
                  <label data-testid="add-user-field-markets" class="block text-sm" for="marketIds">{{ 'USER_UPDATE.ASSIGN_MARKETS' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="markets"
                    [placeholder]="'USER_UPDATE.SELECT_MARKET' | translate"
                    [fieldLabel]="'USER_UPDATE.ASSIGN_MARKETS' | translate"
                    optionLabel="text" optionValue="id"
                    [isMultiselect]="true"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['markets'].rowsPerPageOption || 5"
                    [totalCount]="combosData['markets'].totalRecords"
                    [totalPages]="getComboTotalPages('markets')"
                    [options]="combosData['markets'].list"
                    formControlName="marketIds"
                    (onLazyLoad)="onLazyLoadComboData('markets', $event)">
                  </app-custom-dropdown>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [ngClass]="{'disabled': !isRoleSelected() || isRetailersFieldDisabled }">
                  <label data-testid="add-user-field-retailers" class="block text-sm" for="retailerIds">{{ 'USER_UPDATE.ASSIGN_STORES' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="retailers"
                    [placeholder]="'USER_UPDATE.SELECT_STORE' | translate"
                    [fieldLabel]="'USER_UPDATE.ASSIGN_STORES' | translate"
                    optionLabel="text" optionValue="id"
                    [isMultiselect]="true"
                    [showSelectionChips]="true"
                    [showClear]="true" [searchMode]="'remote'"
                    [pageSize]="combosData['retailers'].rowsPerPageOption || 5"
                    [totalCount]="combosData['retailers'].totalRecords"
                    [totalPages]="getComboTotalPages('retailers')"
                    [options]="combosData['retailers'].list"
                    formControlName="retailerIds"
                    (onLazyLoad)="onLazyLoadComboData('retailers', $event)">
                  </app-custom-dropdown>
                  @if (
                    isMarketsFieldDisabled && (userForm.get('marketIds')?.value?.length ?? 0) > 0 &&
                    (userForm.get('marketIds')?.dirty || userForm.get('marketIds')?.touched)) {
                      <small data-testid="assign-invalid" class="p-error">
                        {{ 'USER_CREATE.NO_RETAILERS_ASSIGNED_TO_SELECTED_MARKETS' | translate }}
                      </small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-user-password-details" class="border-b pb-3">{{ 'USER_CREATE.ACCOUNT_PASSWORD' | translate }}</h2>
                </div>
                <!--
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                    <label class="block text-sm" for="new-pass">
                      {{ 'USER_CREATE.PASSWORD' | translate }}
                      <i class="icon-required-field"></i>
                      <i class="icon icon-info" pTooltip="{{ 'USER_CREATE.PASSWORD_TOOLTIP' | translate }}" tooltipPosition="top">
                      </i>
                    </label>

                    <input type="password" id="new-pass" formControlName="password" tabindex="18" autocomplete="off">

                    @if (
                      userForm.get('password')?.invalid &&
                      (userForm.get('password')?.dirty || userForm.get('password')?.touched)
                    ) {
                      <div class="error-hint-wr">
                        @if (userForm.get('password')?.hasError('required')) {
                          <small class="p-error">
                            {{ 'USER_CREATE.VALIDATE_PASSWORD' | translate }}
                          </small>
                        }

                        @if (userForm.get('password')?.errors?.['invalidPassword']) {
                          <small class="p-error">
                            {{ 'USER_CREATE.FORMAT_PASSWORD' | translate }}
                          </small>
                        }
                      </div>
                    }
                  </div>

                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label class="block text-sm" for="confirm-paswords">
                      {{ 'USER_CREATE.REPEAT_PASSWORD' | translate }}
                      <i class="icon-required-field"></i>
                    </label>

                    <input type="password" id="confirm-password" formControlName="confirmPassword" tabindex="19" autocomplete="off">

                    @if (
                      userForm.get('confirmPassword')?.touched &&
                      userForm.get('confirmPassword')?.invalid
                    ) {
                      <div class="error-hint-wr">
                        @if (userForm.get('confirmPassword')?.hasError('required')) {
                          <small class="p-error">
                            {{ 'USER_CREATE.VALIDATE_CONFIRM_PASSWORD' | translate }}
                          </small>
                        }

                        @if (
                          userForm.get('confirmPassword')?.errors?.['passwordMismatch'] &&
                          !userForm.get('confirmPassword')?.hasError('required')
                        ) {
                          <small class="p-error">
                            {{ 'USER_CREATE.VALIDATE_PASSWORD_MATCH' | translate }}
                          </small>
                        }
                      </div>
                    }
                  </div>
                -->
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <p data-testid="add-user-field-allowpasswordchange" class="mb-2 label">{{ 'USER_CREATE.ALLOW_PASSWORD_CHANGE' | translate }}</p>
                  <div class="flex flex-row">
                    <span data-testid="add-user-foreign-radio-allowpasswordchange-yes" class="inline-flex mr-6">
                      <p-radioButton name="allowPasswordChange" value="true" formControlName="allowPasswordChange" inputId="yes" />
                      <label for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</label>
                    </span>
                    <span data-testid="add-user-foreign-radio-allowpasswordchange-no" class="inline-flex mr-2">
                      <p-radioButton name="allowPasswordChange" value="false" formControlName="allowPasswordChange" inputId="no" />
                      <label for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-user-create-user-button" class="btn primary-btn" [disabled]="isSubmitDisabled()" (click)="submitForm()">{{ 'USER_CREATE.BTN_ADD_NEW_USER' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
